
import { Component, Inject, Renderer2 } from '@angular/core';
import { ServerconfigService } from './core/serverconfig.service';
import { SystemFunctionsService as Sys } from 'src/app/system-functions.service';
import { UtilityService } from 'src/app/utility.service';
import { NavigationEnd, Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { LoaderService } from "./core/loader.service";
import { ApiService } from 'src/app/api.service';
import { AppInjector } from 'src/app/app-injector.module';
import { APIResponseHandlerService } from 'src/app/api-response-handler.service';
import { LoadingBarService } from "@ngx-loading-bar/core";
import 'src/app/window-properties';




@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    public Sys = Sys;
    title = 'AngularApplication';	
     constructor(public serverconfig: ServerconfigService,private us: UtilityService,private router: Router,private renderer: Renderer2, 
                        @Inject(DOCUMENT) private document: Document,
              private spinner: NgxSpinnerService,
              private apiServc: ApiService,
              private apiResponse:APIResponseHandlerService,
              private loadingBar: LoadingBarService,
              private loaderService: LoaderService) {
    }
     ngOnInit() {
this.loaderService.showLoader$.subscribe((value: boolean) => {
      if(value) this.loadingBar.start();
      else this.loadingBar.complete();
    });
    }
}
